export const LEGACY_FIELD_SUFFIX = "(Legacy)";
